import formValidator, {
	required,
	isCorrectEmailLen,
	isSimpleEmail,
} from "@insightfulscience/shared-utils/validation";

export const initialState = {
	email: "",
};

const schema = {
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
		[isSimpleEmail, "errors.WRONG_EMAIL"],
	],
};

export const validateForm = formValidator(schema);
